export const onlyLettersAndSpaces = /^[\u00C0-\u017Fa-zA-Z\s]*$/;
export const onlyNumbers = /^\d*$/;
export const onlyNumbersWithDecimals = /[0-9,\.]*$/;
export const money = /^\d*(\.\d{1,2})*$/;

export const phoneNumber = /^\+?[0-9]{2,}$/;
export const fullPhoneNumber = /^\+[0-9]{2,}$/;

export const ssn = /^([0-9]{8})+-[0-9]{4}$/;
export const hprNumber = /^\d*$/;
export const streetName = /^[\u00C0-\u017Fa-zA-Z0-9\s,.\/]*$/;
export const streetNameWithDash = /^[-\u00C0-\u017Fa-zA-Z0-9\s,.\/]*$/;
export const stringYearOptional = /^$|^\d\d\d\d$/;

export const zipCodeOrEmpty = /($|^[0-9\s-]+$)/;

export const seOrgNum = /^([0-9]{6})+[-][0-9]{4}$/;
export const noOrgNum = /^\d{3}\s\d{3}\s\d{3}$/;
export const seOrgNumOrEmpty = /^$|^[0-9]{6}-[0-9]{4}$/;

export const clearingNumber = /^\d{4}$/;

export const ip = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/;
